import { Mail, Ban, LucideIcon } from 'lucide-react';
import { type UserStatus } from '@bliks-io/contracts';

/**
 * Configuration for individual status actions
 */
export type StatusActionConfig = {
  icon: LucideIcon;
  messageKey: string;
  buttonLabelKey: string;
  alertVariant?: 'default' | 'destructive';
  buttonVariant?:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'destructive'
    | 'outline'
    | 'ghost'
    | 'link'
    | 'primary-light';
  handler: 'onSendInvitation' | 'onUnsuspend' | 'onSuspend';
  loadingProp: 'isSendingInvitation' | 'isUnsuspending' | 'isSuspending';
};

/**
 * Configuration map for status-specific actions
 * Each status can have multiple actions
 */
export const STATUS_ACTIONS_CONFIG: Record<UserStatus, StatusActionConfig[]> = {
  inactive: [
    {
      icon: Mail,
      messageKey: 'organization.members.userInactive',
      buttonLabelKey: 'organization.members.sendInvitationAction',
      handler: 'onSendInvitation',
      loadingProp: 'isSendingInvitation'
    }
  ],
  pending: [
    {
      icon: Mail,
      messageKey: 'organization.members.userPendingInvitation',
      buttonLabelKey: 'organization.members.resendInvitationAction',
      handler: 'onSendInvitation',
      loadingProp: 'isSendingInvitation'
    },
    {
      icon: Ban,
      messageKey: 'organization.members.suspendUserPrompt',
      buttonLabelKey: 'organization.members.suspendUser',
      buttonVariant: 'destructive',
      handler: 'onSuspend',
      loadingProp: 'isSuspending'
    }
  ],
  active: [
    {
      icon: Ban,
      messageKey: 'organization.members.suspendUserPrompt',
      buttonLabelKey: 'organization.members.suspendUser',
      buttonVariant: 'destructive',
      handler: 'onSuspend',
      loadingProp: 'isSuspending'
    }
  ],
  suspended: [
    {
      icon: Ban,
      messageKey: 'organization.members.userSuspended',
      buttonLabelKey: 'organization.members.unsuspendUser',
      alertVariant: 'destructive',
      handler: 'onUnsuspend',
      loadingProp: 'isUnsuspending'
    }
  ]
};
